
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap",
      function () {
        return require("private-next-pages/sitemap.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap"])
      });
    }
  